import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function VenueFormDialog({
  open,
  onClose,
  onSubmit,
  initialData,
  loading,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [name, setName] = useState("");

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || "");
    } else {
      setName("");
    }
  }, [initialData, open]);

  const handleSave = () => {
    onSubmit({ name: name.trim() });
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: "18px",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          fontWeight: 700,
          fontSize: "1.05rem",
        }}
      >
        {initialData ? "Editar sede" : "Nueva sede"}
      </DialogTitle>

      <DialogContent sx={{ pt: 2.2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.4 }}>
          <TextField
            autoFocus
            fullWidth
            label="Nombre de la sede"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mt: 3 }}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2.4,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading || !name.trim()}
        >
          {loading
            ? "Guardando..."
            : initialData
            ? "Actualizar"
            : "Crear"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}